export default () => ({
    state_preferences: '',
    status_request_login: null
    // fullname: null,
    // lastname: null,
    // datebirth: null,
    // email: null,
    // statususer: null
})